if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      this.prependMedia = this.dataset.disablePrepend != 'true';
      // NEW: auto-scroll opt-out
      this.autoScroll = this.dataset.disableAutoscroll != 'true';
      if (!this.elements.thumbnails) return;

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
      });
      if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
    }

    onSlideChanged(event) {
      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
      this.setActiveThumbnail(thumbnail);
    }

    setActiveMedia(mediaId, prepend) {
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      if (!activeMedia) return;
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');

      if (prepend && this.prependMedia) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        // NEW: honour data-disable-autoscroll
        if (this.autoScroll && (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked')) {
          activeMedia.scrollIntoView({ behavior: 'smooth' });
        }
      });
      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      thumbnail.querySelector('button').setAttribute('aria-current', true);
      if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

      this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}

/*
  Gallery thumbnails (product page + Featured product)
  Product page aur Featured product, dono galleries ke liye ek hi thumbnail strip.
  - Desktop (>= 750px): 4 thumbnails, centre mode, infinite (4 se zyada images par), arrows
  - Mobile (< 750px): thumbnails CSS se hidden hain, wahan main slider ke dots dikhte hain
  Main slider hi "source of truth" hai. Thumbnails sirf usko follow / control karte hain.

  Use:  window.initGalleryThumbs(mainSwiper, thumbBoxElement)

  Markup:
    <div class="gallery-thumbs">
      <div class="swiper gallery-thumbs__swiper">
        <div class="swiper-wrapper"> ...swiper-slide... </div>
      </div>
      <div class="gallery-thumbs__arrow gallery-thumbs__arrow--prev" role="button" tabindex="0"></div>
      <div class="gallery-thumbs__arrow gallery-thumbs__arrow--next" role="button" tabindex="0"></div>
    </div>
*/
(function () {
  if (window.initGalleryThumbs) return;

  var DESKTOP_QUERY = '(min-width: 750px)';
  var SHOW = 4;        // ek saath dikhne wale thumbnails (Slick slidesToShow jaisa)
  var PAD = 20;        // centre mode padding (Slick centerPadding jaisa)
  var GAP = 10;        // thumbnails ke beech gap
  var DRAG_LIMIT = 10; // 10px se zyada hila to swipe, warna tap / click

  // Slick jaisi slide width: (strip width - 2*padding - gaps) / 4
  function perView(el) {
    var w = el.clientWidth;
    if (!w) return SHOW;
    var slideW = (w - PAD * 2 - GAP * (SHOW - 1)) / SHOW;
    if (slideW <= 0) return SHOW;
    return (w + GAP) / (slideW + GAP);
  }

  function indexOfSlide(slide) {
    var v = slide ? parseInt(slide.getAttribute('data-thumb-index'), 10) : NaN;
    return isNaN(v) ? -1 : v;
  }

  function listenMedia(mql, fn, on) {
    if (mql.addEventListener) mql[on ? 'addEventListener' : 'removeEventListener']('change', fn);
    else if (mql.addListener) mql[on ? 'addListener' : 'removeListener'](fn);
  }

  function setup(main, box) {
    if (box._galleryThumbs) box._galleryThumbs.destroy();
    if (main.destroyed) return;

    var thumbEl = box.querySelector('.gallery-thumbs__swiper');
    var wrapper = thumbEl ? thumbEl.querySelector('.swiper-wrapper') : null;
    if (!wrapper) return;

    var prevBtn = box.querySelector('.gallery-thumbs__arrow--prev');
    var nextBtn = box.querySelector('.gallery-thumbs__arrow--next');

    // Main slider wala hi Swiper version use karo (page par koi aur version load ho tab bhi)
    var SwiperClass = main.constructor;

    if (thumbEl.swiper) thumbEl.swiper.destroy(true, true);

    // Pichhle init ki copies ho to hata do (dobara init safe rahe)
    wrapper.querySelectorAll('[data-thumb-clone]').forEach(function (el) {
      el.parentNode.removeChild(el);
    });

    var originals = Array.prototype.filter.call(wrapper.children, function (el) {
      return el.classList.contains('swiper-slide');
    });
    var count = originals.length;
    if (!count) return;

    originals.forEach(function (slide, i) {
      slide.setAttribute('data-thumb-index', i);
    });

    // 4 se zyada images: infinite + centre mode. Warna sab ek saath dikhenge, arrows nahi.
    var canLoop = count > SHOW;

    function makeClone(slide) {
      var clone = slide.cloneNode(true);
      clone.setAttribute('data-thumb-clone', '');
      clone.setAttribute('aria-hidden', 'true');
      return clone;
    }

    if (canLoop) {
      // Slick jaisa infinite: originals ke aage aur peeche ek-ek poora set
      var before = document.createDocumentFragment();
      originals.forEach(function (slide) { before.appendChild(makeClone(slide)); });
      wrapper.insertBefore(before, originals[0]);
      originals.forEach(function (slide) { wrapper.appendChild(makeClone(slide)); });
    }

    if (prevBtn) prevBtn.style.display = canLoop ? '' : 'none';
    if (nextBtn) nextBtn.style.display = canLoop ? '' : 'none';

    var startIndex = main.realIndex || 0;

    // Thumbnails par Swiper loop nahi (usse blank space aata tha); infinite clones se banta hai
    var thumbs = new SwiperClass(thumbEl, {
      slidesPerView: perView(thumbEl),
      spaceBetween: GAP,
      centeredSlides: canLoop,
      initialSlide: canLoop ? count + startIndex : 0,
      slidesOffsetBefore: canLoop ? 0 : PAD,
      allowTouchMove: canLoop,
      threshold: 5, // 5px se kam hilna swipe nahi, click maana jaye
      watchSlidesProgress: true
    });

    function markActive(i) {
      thumbEl.querySelectorAll('.swiper-slide').forEach(function (slide) {
        slide.classList.toggle('is-active', indexOfSlide(slide) === i);
      });
    }

    // Active thumbnail copy set mein chali jaye to bina animation beech wale set mein le aao
    var normalizing = false;
    function keepInMiddle() {
      if (!canLoop || normalizing) return;
      var a = thumbs.activeIndex;
      if (a < count || a >= count * 2) {
        normalizing = true;
        thumbs.slideTo((a % count) + count, 0, false);
        normalizing = false;
      }
    }

    // Main image wali thumbnail ko beech mein laao (sabse paas wali copy)
    function centerOn(i) {
      if (!canLoop) return;
      keepInMiddle();
      var a = thumbs.activeIndex;
      if (a % count === i) return;
      var best = i + count;
      var bestDist = Infinity;
      for (var k = 0; k < 3; k++) {
        var j = i + k * count;
        var d = Math.abs(j - a);
        if (d < bestDist) {
          bestDist = d;
          best = j;
        }
      }
      thumbs.slideTo(best);
    }

    function onMainChange() {
      markActive(main.realIndex);
      centerOn(main.realIndex);
    }
    main.on('slideChange', onMainChange);

    // Thumbnail select: Swiper pointer capture ki wajah se click / pointerup ka target
    // strip container ban jaata hai, isliye thumbnail ko pointerdown par hi pehchaano
    var downX = null;
    var downSlide = null;
    var realDrag = false;

    // Click ki position par kaunsi thumbnail hai (event target par depend nahi)
    function slideAt(x, y) {
      var slides = thumbEl.querySelectorAll('.swiper-slide');
      for (var s = 0; s < slides.length; s++) {
        var r = slides[s].getBoundingClientRect();
        if (x >= r.left && x <= r.right && y >= r.top && y <= r.bottom) return slides[s];
      }
      return null;
    }

    function onDown(e) {
      if (typeof e.button === 'number' && e.button !== 0) return; // sirf left click / touch
      if (e.target.closest && e.target.closest('.gallery-thumbs__arrow')) return; // arrows apna kaam karte hain
      downX = e.clientX;
      downSlide = slideAt(e.clientX, e.clientY);
      realDrag = false;
    }

    // Chhodne par decide karo: swipe tha ya thumbnail par tap
    function onUp(e) {
      if (downX === null) return;
      var moved = Math.abs(e.clientX - downX) > DRAG_LIMIT;
      var slide = downSlide;
      realDrag = moved;
      downX = null;
      downSlide = null;
      if (moved || !slide) return;
      var i = indexOfSlide(slide);
      if (i >= 0 && i !== main.realIndex) main.slideToLoop(i);
    }

    // Page scroll ya koi aur wajah se touch cancel ho to kuch select mat karo
    function onCancel() {
      downX = null;
      downSlide = null;
    }

    box.addEventListener('pointerdown', onDown, true);
    window.addEventListener('pointerup', onUp, true);
    window.addEventListener('pointercancel', onCancel, true);

    // Animation khatam: beech wale set mein lao, aur asli swipe hua ho to main ko move karo
    thumbs.on('transitionEnd', function () {
      if (normalizing) return;
      keepInMiddle();
      if (!realDrag) return;
      realDrag = false;
      var i = indexOfSlide(thumbs.slides[thumbs.activeIndex]);
      if (i >= 0 && i !== main.realIndex) main.slideToLoop(i);
    });

    // Thumbnail arrows: main image ek aage / peeche
    function bindArrow(el, action) {
      if (!el) return function () {};
      function onKey(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          action();
        }
      }
      el.addEventListener('click', action);
      el.addEventListener('keydown', onKey);
      return function () {
        el.removeEventListener('click', action);
        el.removeEventListener('keydown', onKey);
      };
    }
    var unbindPrev = bindArrow(prevBtn, function () { main.slidePrev(); });
    var unbindNext = bindArrow(nextBtn, function () { main.slideNext(); });

    // Screen size badalne par bhi Slick jaisi width bani rahe
    thumbs.on('resize', function () {
      var spv = perView(thumbEl);
      if (Math.abs(spv - thumbs.params.slidesPerView) > 0.01) {
        thumbs.params.slidesPerView = spv;
        thumbs.update();
      }
    });

    markActive(startIndex);

    box._galleryThumbs = {
      destroy: function () {
        main.off('slideChange', onMainChange);
        box.removeEventListener('pointerdown', onDown, true);
        window.removeEventListener('pointerup', onUp, true);
        window.removeEventListener('pointercancel', onCancel, true);
        unbindPrev();
        unbindNext();
        if (!thumbs.destroyed) thumbs.destroy(true, true);
        wrapper.querySelectorAll('[data-thumb-clone]').forEach(function (el) {
          el.parentNode.removeChild(el);
        });
        box._galleryThumbs = null;
      }
    };
  }

  window.initGalleryThumbs = function (main, box) {
    if (!main || !box) return;

    if (box._thumbsWait) {
      listenMedia(box._thumbsWait.mql, box._thumbsWait.fn, false);
      box._thumbsWait = null;
    }

    var mql = window.matchMedia(DESKTOP_QUERY);
    if (mql.matches) {
      setup(main, box);
      return;
    }

    // Mobile par thumbnails chahiye nahi. Screen desktop size ki ho (rotate / resize) tab setup karo.
    var fn = function (e) {
      if (!e.matches) return;
      listenMedia(mql, fn, false);
      box._thumbsWait = null;
      setup(main, box);
    };
    box._thumbsWait = { mql: mql, fn: fn };
    listenMedia(mql, fn, true);
  };
})();